import styled from 'styled-components'

export const DeleteProposalContent = styled.div``
